<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link v-if="is_admin_dealer" to="/admin/manage/producers" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <router-link v-else to="/admin/producers" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Händler hinzufügen</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newProviderForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-10 form-div">
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Vorname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.firstName"
                          :error-messages="errors[0]"
                          label="Vorname"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Nachname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.lastName"
                          :error-messages="errors[0]"
                          label="Nachname"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="email"
                        rules="required|email"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die E-Mail ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.email"
                          :error-messages="errors[0]"
                          label="E-Mail"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="phone"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Telefonnummer ist erforderlich',
                        }"
                      >
                        <vue-tel-input
                          :class="errors[0] ? 'error-outline' : ''"
                          v-on:country-changed="countryChanged"
                          :validCharactersOnly="true"
                          :enabledCountryCode="false"
                          :defaultCountry="form.phoneCountry"
                          :onlyCountries="countryArr"
                          mode="international"
                          v-model="form.phone"
                          placeholder="Telefonnummer"
                        ></vue-tel-input>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Markenname ist erforderlich',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.brandName"
                      :error-messages="errors[0]"
                      label="Markenname"
                      outlined
                      @input="createSlug()"
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Firmenname ist erforderlich',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.companyName"
                      :error-messages="errors[0]"
                      label="Firmenname"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Address is required.',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.providerAddress"
                      :error-messages="errors[0]"
                      label="Adresse"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="Country"
                        rules="required|alpha"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Land ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.country"
                          :error-messages="errors[0]"
                          label="Land"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Bundesland ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="statesList"
                          v-model="form.state"
                          :error-messages="errors[0]"
                          item-text="name"
                          item-value="id"
                          label="Bundesland"
                          outlined
                          clearable
                        />
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="City"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Stadt ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.city"
                          :error-messages="errors[0]"
                          label="Stadt"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="Postal Code"
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'die Postleitzahl ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="text"
                          autocomplete="new-password"
                          v-model="form.postCode"
                          :error-messages="errors[0]"
                          label="Postleitzahl"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="Password"
                        vid="password"
                        rules="required|passwordInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Password is required.',
                        }"
                      >
                        <div class="password-input-div">
                          <v-text-field
                            autocomplete="new-password"
                            ref="password"
                            :error-messages="errors[0]"
                            :type="show === true ? 'text' : 'password'"
                            v-model="form.password"
                            label="Passwort"
                            outlined
                            @input="passwordCheck"
                          ></v-text-field>
                          <i
                            class="fas fa-eye show-icon"
                            v-if="show"
                            @click="show = !show"
                          ></i>
                          <i
                            class="fas fa-eye-slash show-icon"
                            v-else
                            @click="show = !show"
                          ></i>
                        </div>
                        <div
                          v-if="form.password"
                          class="row password-strength mt-3"
                        >
                          <div class="col-md-10 p-0">
                            <v-progress-linear
                              :value="progressValue"
                              :color="progressColor"
                            ></v-progress-linear>
                          </div>
                          <div class="col-md-2 pr-0 text-right">
                            <span>{{ passwordStrength }}</span>
                          </div>
                        </div>
                        <span class="note-text text-secondary"
                          >Das Passwort muss mindestens 8 Zeichen, sowie eine
                          Kombination von Sonderzeichen, Zahlen, Groß- und
                          Kleinbuchstaben enthalten.</span
                        >
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="confirm password"
                        rules="required|confirmed:password"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Bitte das Passwort bestätigen',
                        }"
                      >
                        <div class="password-input-div">
                          <v-text-field
                            autocomplete="new-password"
                            ref="password"
                            :error-messages="errors[0]"
                            :type="show2 === true ? 'text' : 'password'"
                            v-model="form.rePassword"
                            label="Passwort bestätigen"
                            outlined
                          ></v-text-field>
                          <i
                            class="fas fa-eye show-icon"
                            v-if="show2"
                            @click="show2 = !show2"
                          ></i>
                          <i
                            class="fas fa-eye-slash show-icon"
                            v-else
                            @click="show2 = !show2"
                          ></i>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <span>
                      Diese Provision wird auf alle Bestellungen angewendet
                    </span>
                    <b-form-group class="mt-5">
                      <ValidationProvider
                        rules="priceInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'This is required.',
                        }"
                      >
                        <v-text-field
                          :error-messages="errors[0]"
                          autocomplete="new-password"
                          v-model="form.commission"
                          label="Provision (%)"
                          outlined
                          clearable
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- Meta description added -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Händler Meta Beschreibung ist erforderlich',
                        }"
                      > -->
                        <!-- <ckeditor
                          v-model="form.productMetaDescription"
                          :config="editorConfig"
                        ></ckeditor> -->
                        <v-text-field
                          v-model="form.producerMetaDescription"
                          label="Händler Meta Beschreibung für SEO (max. 160 Zeichen, Standard: Händler Beschreibungstext)"
                          outlined
                          maxlength="160"
                        ></v-text-field>
                        <!-- <span class="text-danger"
                          ><b>{{ errors[0] }}</b></span
                        > -->
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max50"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Händler Name ist erforderlich',
                        }"
                      >
                        <v-text-field
                          v-model="form.producerMetaTitle"
                          :error-messages="errors[0]"
                          label="Händler Meta Name für SEO (max. 50 Zeichen, Standard: Händler Name)"
                          outlined
                          @blur="restorePopUp(e=1)"
                        ></v-text-field>
                        <span v-if="form.producerMetaTitle && form.producerMetaTitle.length >50" class="text-danger"><b>{{ errors[0] }}</b></span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">

                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Händler Canonical Link ist erforderlich',
                        }"
                      >
                        <v-text-field
                          v-model="form.producerCanonicalLink"
                          :error-messages="errors[0]"
                          label="Händler Canonical Link für SEO (Standard: Händler URL)"
                          outlined
                          @blur="restorePopUp(e=2)"
                        ></v-text-field>
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Händler Meta Robots ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="robotValues"
                          v-model="form.producerMetaRobots"
                          :error-messages="errors[0]"
                          item-text="lable"
                          item-value="value"
                          label="Händler Meta Robots Einstellung für SEO (Standard: index, follow)"
                          outlined clearable
                        />
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>                 

                <b-form-group>
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Aktiviert' : 'Deaktiviert'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
        <v-dialog v-model="statusDialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Bitte bestätigen
            </v-card-title>
            <v-card-text>
              <span>Möchten Sie den Wert wiederherstellen?</span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                :disabled="disabledCancel"
                class="no-button"
                @click="hideModal"
              >
                Nein
              </v-btn>
              <v-btn
                type="submit"
                @click="restore()"
                ref="kt_form_submit_btn"
                class="yes-button"
                :loading="yesActionLoading"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <notifications group="producers" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
//import axios from "axios";
import Notifications from "vue-notification";
//import JwtService from "@/core/services/jwt.service";
//import { alpha } from 'vee-validate';
import config from "@/config/app";
import VueTelInput from "vue-tel-input";
import adminAPI from "@/api/admin";
import { extend } from "vee-validate";
import metarobots from "@/config/constant";

Vue.use(VueTelInput);

Vue.use(Notifications);

extend("passwordInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^(?=.*[A-Za-z])(?=.*[!@#$%^&*()_+,.\\\/;':"-]).{8,}$/;
    var validPassword = regx.test(value);
    if (validPassword) {
      return true;
    } else {
      false;
    }
  },
});

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("max50", {
  message: (field) => "Händler Meta Name: maximal 50 Zeichen",
  validate: (value) => {
    var regx = /^.{0,50}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("noSpecialCharacters", {
  message: (field) => "Bitte entfernen Sonderzeichen",
  validate: (value) => {
    var regx = /^[a-zA-Z0-9\s]*$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "AddProducer",
  props:{
    data:{
      type: String,
      required: true
    }
  },
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.getGeneralSettings();
      this.getStates();
      this.robotValues = metarobots;
      if(this.robotValues.length > 0){
       this.form.producerMetaRobots = this.robotValues[0].value
      }
    }
    console.log('add', this.is_admin_dealer)
  },
  data() {
    return {
      is_admin_dealer:this.data ? this.data: 0,
      countryArr: config.availableCountries,
      formError: false,
      userId: null,
      isLoading: false,
      pdfFileString: null,
      formData: [],
      robotValues: [],
      statesList: [],
      pdfFileTest: "",
      btnDisable: false,
      show: false,
      show2: false,
      isPoor: false,
      isGood: false,
      isStrong: false,
      passwordStrength: "Poor",
      countryDialCode: "43",
      submitText: "Abschicken",
      contains_lovercase: false,
      contains_number: false,
      contains_uppercase: false,
      containSpecialChar: false,
      status: true,
      progressValue: 0,
      progressColor: "error",
      form: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        phoneCountry: 'AT',
        companyName: "",
        brandName: "",
        providerAddress: "",
        country: "Österreich",
        state: "",
        city: "",
        postCode: "",
        password: null,
        rePassword: null,
        commission: "",
        producerMetaDescription: '',
        producerMetaTitle: '',
        producerCanonicalLink: '',
        producerMetaRobots: ''        
      },
      statusDialog: false,
      restoreField:null
    };
  },
  watch: {
    "form.brandName": function (value) {
        this.form.producerMetaTitle = value.substring(0,50);
    },
  },
  methods: {
    getStates() {
      adminAPI
        .getStates()
        .then((response) => {
          if (response.status == "success") {
            this.statesList = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getGeneralSettings() {
      adminAPI
        .getGeneralSetting({ id: this.currentUser.id })
        .then((response) => {
          if (response.status == "success") {
            this.form.commission = response.data.dealer_commission;
          }
        })
        .catch((err) => {
        });
    },
    goToBack() {
      if (this.is_admin_dealer) {
        this.$router.push({ name: "manage-producers" });
      } else {
        this.$router.push({ name: "producers" });
      }
    },
    countryChanged(country) {
      this.countryDialCode = country.dialCode;
      this.form.phoneCountry = country.iso2;
    },
    passwordCheck(val) {
      this.contains_lovercase = /[a-z]/.test(this.form.password);
      this.contains_number = /\d/.test(this.form.password);
      this.contains_uppercase = /[A-Z]/.test(this.form.password);
      this.containSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
        this.form.password
      );

      if (this.form.password.length > 0 && this.form.password.length <= 8) {
        this.isPoor = true;
        this.passwordStrength = "Poor";
        this.progressValue = 33;
        this.progressColor = "error";
      } else {
        this.isPoor = false;
      }
      if (this.form.password.length > 8) {
        this.isGood = true;
        this.passwordStrength = "Good";
        this.progressValue = 66;
        this.progressColor = "yellow darken-2";
      } else {
        this.isGood = false;
      }
      if (
        this.form.password.length > 8 &&
        this.contains_lovercase &&
        this.contains_number &&
        this.contains_uppercase &&
        this.containSpecialChar
      ) {
        this.isStrong = true;
        this.passwordStrength = "Strong";
        this.progressValue = 100;
        this.progressColor = "green";
      } else {
        this.isStrong = false;
      }
    },
    onSubmit() {
      this.$refs.newProviderForm.validate().then((success) => {
        if (success) {
          this.formError = false;
          this.btnDisable = true;
          this.submitText = "Wird abgeschickt...";

          //-----country code
          const germanyPattern = /^(\+|00)49/;
          const austriaPattern = /^(\+|00)43/;

          // Check if the phone number matches either pattern
          const isGermanNumber = germanyPattern.test(this.form.phone);
          const isAustrianNumber = austriaPattern.test(this.form.phone);

          if (isGermanNumber) {
            console.log('+49 (Germany)');
          } else if (isAustrianNumber) {
            console.log('+43 (Austria)');
          } else {
            var phoneNumber = this.form.phone
            this.form.phone = '+'+this.countryDialCode+' '+phoneNumber
          }

          //-----------
          let formData = {
            first_name: this.form.firstName,
            last_name: this.form.lastName,
            email: this.form.email,
            phone: this.form.phone,
            country_code: this.form.phoneCountry,
            company_name: this.form.companyName,
            brand_name: this.form.brandName,
            address: this.form.providerAddress,
            country: this.form.country,
            state_id: this.form.state,
            city: this.form.city,
            postcode: this.form.postCode,
            password: this.form.password,
            status: this.status == true ? "1" : "0",
            commission: this.form.commission,
            meta_description:this.form.producerMetaDescription,
            title:this.form.producerMetaTitle,
            canonical_link:this.form.producerCanonicalLink,
            meta_robots: this.form.producerMetaRobots,
            is_admin_dealer:this.is_admin_dealer
          };

          setTimeout(() => {
            adminAPI
              .addProducer(formData)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Abschicken";
                  this.btnDisable = false;
                  // send data to Google tag manager
                 // dataLayer.push({event: 'Account registered',eventCategory: 'Account','eventAction': 'registration',eventLabel: 'dealer',debug_mode:true});
                  // send data to google Analytics
                  /* ga('Account registriert', {
                    hitType: 'event',
                    eventCategory: 'Account',
                    eventAction: 'Registrierung'
                  }); */
                  // if (process.env.NODE_ENV === 'production') {
                  //   this.$ga.event('Account', 'Registrierung', 'Produzent');
                  // }                  
                  this.$notify({
                    group: "producers",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    if (this.is_admin_dealer) {
                      this.$router.push({ name: "manage-producers" });
                    } else {
                      this.$router.push({ name: "producers" });
                    }
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Abschicken";

                  this.$notify({
                    group: "producers",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Abschicken";

                this.$notify({
                  group: "producers",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.$notify({
            group: "producers",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Abschicken";
        }
      });
    },
    createSlug() {console.log('sadasdads')
      // this.form.producerMetaTitle = this.form.brandName.substring(0,50);
      let formData = {
            name: this.form.brandName,
      }
      adminAPI
        .createSlug(formData)
        .then((response) => {
          if (response.status == "success") {
            if(window.location.origin === 'http://localhost:8080'){
              this.form.producerCanonicalLink = 'http://localhost:3000/haendler-details/'+response.data.slug
            }else if(window.location.origin === 'https://stage-admin.gustoreich.at'){
              this.form.producerCanonicalLink = 'https://stage.gustoreich.at/haendler-details/'+response.data.slug
            }else{
              this.form.producerCanonicalLink = 'https://gustoreich.at/haendler-details/'+response.data.slug
            }
          } else {
            this.form.producerCanonicalLink = '';
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    restorePopUp(e){
      if((e=='1') && (!this.form.producerMetaTitle)&& (this.form.brandName)){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='2') && (!this.form.producerCanonicalLink) && (this.form.brandName)){
        this.restoreField = e;
        this.statusDialog = true;
      }
      
    },
    hideModal(){
      this.statusDialog = false
    },
    restore(){
      if(this.restoreField == '1') {
        this.form.producerMetaTitle = this.form.brandName.substring(0,50);
      }else if(this.restoreField == '2') {
        this.createSlug();
      }
      this.statusDialog = false
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"]),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.show-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.strendth-div {
  border: 1px solid lightgrey;
  height: 7px;
  margin: 2px;
  border-radius: 10px;
}

.red {
  background-color: red;
}

.orange {
  background-color: orange;
}

.green {
  background-color: green;
}
.password-input-div {
  position: relative;
}
.note-text {
  font-size: 12px;
}
</style>
